module.exports = __webpack_public_path__ + "img/airplane-5.7d4db9a3.jpg";